// extracted by mini-css-extract-plugin
var _1 = "assets-js-GalleryPB-components-GalleryPromoTile-GalleryPromoTile-module__galleryPromoTile__wEv49";
var _2 = "assets-js-GalleryPB-components-GalleryPromoTile-GalleryPromoTile-module__galleryPromoTileImage__O8E9f";
export { _1 as "galleryPromoTile", _2 as "galleryPromoTileImage" }
